import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import type { AuthUser } from '../../hooks/useAuth';

interface RoleGuardProps {
  requiredRole: AuthUser['role'] | AuthUser['role'][];
  children: ReactNode;
  fallback?: string;
}

export function RoleGuard({ requiredRole, children, fallback }: RoleGuardProps) {
  const { user, loading, hasRole } = useAuth();

  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;

  const roles = Array.isArray(requiredRole) ? requiredRole : [requiredRole];
  const allowed = roles.some((role) => hasRole(role));

  if (!allowed) {
    // Freelancer roles (EDITOR/TRANSLATOR/DESIGNER) go to /my-tasks, others to /dashboard
    const isFreelancer = (['EDITOR', 'TRANSLATOR', 'DESIGNER'] as const).includes(user.role as never);
    const defaultFallback = isFreelancer ? '/my-tasks' : '/dashboard';
    return <Navigate to={fallback ?? defaultFallback} replace />;
  }

  return <>{children}</>;
}
